"use client";

import { create } from "zustand";
import { User } from "@/types/auth.types";

interface AuthState {
    user: User | null;
    isAuthenticated: boolean;
    isLoading: boolean;
    setUser: (user: User | null) => void;
    clearUser: () => void;
    setLoading: (isLoading: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
    user: null,
    isAuthenticated: false,
    isLoading: true,
    setUser: (user) => set({ 
        user, 
        isAuthenticated: !!user, 
        isLoading: false 
    }),
    clearUser: () => {
        set({ 
            user: null, 
            isAuthenticated: false, 
            isLoading: false 
        });
    },
    setLoading: (isLoading) => set({ isLoading }),
}));
